// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconKlarnaKPath = 'M7 18H5V2h2v16Zm7.236 0 2.424-.007-5.902-7.168 1.024-.879C14.267 7.811 15.563 5.007 15.923 2l-1.84.006c-.393 2.988-2.337 5.823-5.255 7.817-.478.326-.555 1.002-.185 1.447L14.236 18Z';
var IconKlarnaK = baseIcon('IconKlarnaK', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconKlarnaKPath
});
export default IconKlarnaK;
//# sourceMappingURL=index.js.map